import { Component, OnInit, Input } from '@angular/core';
import { AuditModel } from '../../models/interpretation.model';
import { InterpretationService } from '../../interpretation.service';
import { NotificationsService } from 'angular2-notifications';
import { CryptoService } from '../../../../services/crypto.service';

@Component({
  selector: 'audit-log',
  templateUrl: './audit-log.component.html',
  styleUrls: ['./audit-log.component.scss']
})
export class AuditLogComponent implements OnInit {
  // Audit
  @Input() inspectionId: number;
  auditLog: AuditModel[] = [];

  constructor(private _interp: InterpretationService,
  private _notify: NotificationsService,
  private _crypto: CryptoService) { }

  ngOnInit() {
    this.loadAuditLog();
  }

  loadAuditLog() {
    this._interp.getAuditLog(this.inspectionId).subscribe(log => {
      this.auditLog = log;
      //AES256
      this.auditLog.forEach((aud: any) => {
        if (aud?.UserEmail && aud.UserEmail.length > 0) {
          aud.UserEmail = this._crypto.decrypt(aud.UserEmail);
        }
        if (aud?.UserName && aud.UserName.length > 0) {
          aud.UserName = this._crypto.decrypt(aud.UserName);
        }
      });
    }, err => {
      this._notify.error('Error', 'Unable to load audit log. Contact TrackTreads support. ');
      console.error(err);
    });
  }
}
